import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonService } from 'src/@services/common.service';
import { InnerPagesService } from 'src/app/pages/common-layout/inner-pages.service';
import { CommonPagesService } from '../../common-pages.service';
import { ResponseStatus, RoleType } from '../../enum';

@Component({
  selector: 'app-add-update-emails-defaults',
  templateUrl: './add-update-emails-defaults.component.html',
  styleUrls: ['./add-update-emails-defaults.component.scss'],

  standalone: false,
})
export class AddUpdateEmailsDefaultsComponent implements OnInit {
  isVisibleEmailsDrawer = true;
  @Input() selectedRoleDataEmailDefault: any;
  @Input() currentSelectedTab: any;
  @Output() hideEmailsDrawer = new EventEmitter();
  isEmailsLoading: boolean = false;
  allPaymentChecked = false;
  allInvestmentChecked = false;
  allCancellationChecked = false;
  allChecked = false;
  allSupplierChecked = false;
  emailDefault: any;
  supplierEmailDefault
  isLoadingOne = false;
  canEditRole: Boolean = false;
  currentSelectEmailDefaultTab: any = 0;
  // notificationsDetails: any;
  notificationsList: any;
  constructor(
    public _cs: CommonService,
    private _ws: CommonPagesService,
    private _iS: InnerPagesService
  ) { }

  get RoleType() {
    return RoleType
  }

  ngOnInit(): void {

    this.emailDefault = JSON.parse(
      JSON.stringify(this.selectedRoleDataEmailDefault.emailDefaultsAction)
    );

    this.supplierEmailDefault = this.selectedRoleDataEmailDefault.supplierEmailDefaultsAction ? JSON.parse(JSON.stringify(this.selectedRoleDataEmailDefault.supplierEmailDefaultsAction)) : [];

    // this.notificationsDetails = response.result;
    // this.notificationsList = this.notificationsDetails?.emailDefaults;
    this.notificationsList = JSON.parse(JSON.stringify(this.emailDefault));
    const data: any = Object.values(
      this.emailDefault.reduce((acc, curr) => {
        // If the type group doesn't exist, create it with an empty array
        if (!acc[curr.type]) {
          acc[curr.type] = {
            header: curr.type,
            items: [],
          };
        }
        // Add the current item to the corresponding group
        acc[curr.type].items.push({
          item: curr.name,
          isJustMine: curr.isJustMine,
          isAll: curr.isAll,
          isChecked: curr.isJustMine,
        });
        return acc;
      }, {})
    );
    this.emailDefault = data;
    this.canEditRole = this._iS.canAccessRoles().canEditRole;
    this.emailDefault.forEach((object: any) => {
      if (object.items.every((item: any) => item.isChecked)) {
        object.items.forEach((subobject: any) => {
          if (subobject.isChecked) {
            object.isChecked = true;
          }
        });
      }
    });

    if (this.emailDefault.every((item: any) => item.isChecked)) {
      this.allChecked = true;
    } else {
      this.allChecked = false;
    }


    this.currentSelectedTab == RoleType.Supplier ? this.initializeSupplierDefaultData() : null;
  }

  initializeSupplierDefaultData() {
    const data: any = Object.values(
      this.supplierEmailDefault.reduce((acc, curr) => {
        // If the type group doesn't exist, create it with an empty array
        if (!acc[curr.type]) {
          acc[curr.type] = {
            header: curr.type,
            items: [],
          };
        }
        // Add the current item to the corresponding group
        acc[curr.type].items.push({
          item: curr.name,
          isJustMine: curr.isJustMine,
          isAll: curr.isAll,
          isChecked: curr.isJustMine,
        });
        return acc;
      }, {})
    );
    this.supplierEmailDefault = data;

    this.supplierEmailDefault.forEach((object: any) => {
      if (object.items.every((item: any) => item.isChecked)) {
        object.items.forEach((subobject: any) => {
          if (subobject.isChecked) {
            object.isChecked = true;
          }
        });
      }
    });

    if (this.supplierEmailDefault.every((item: any) => item.isChecked)) {
      this.allSupplierChecked = true;
    } else {
      this.allSupplierChecked = false;
    }
  }

  onTabChange(event: any) {
    this.currentSelectEmailDefaultTab = event;
  }

  updateAllChecked(): void {
    if (this.allChecked) {
      this.emailDefault.forEach((item: any) => {
        item.isChecked = true;
      });
      this.emailDefault.forEach((x: any) => {
        x.items.forEach((subobject: any) => {
          subobject.isChecked = true;
        });
      });
    } else {
      this.emailDefault.forEach((item: any) => {
        item.isChecked = false;
      });

      this.emailDefault.forEach((x: any) => {
        x.items.forEach((subobject: any) => {
          subobject.isChecked = false;
        });
      });
    }
  }

  updateAllSupplierChecked() {
    if (this.allSupplierChecked) {
      this.supplierEmailDefault.forEach((item: any) => {
        item.isChecked = true;
      });
      this.supplierEmailDefault.forEach((x: any) => {
        x.items.forEach((subobject: any) => {
          subobject.isChecked = true;
        });
      });
    } else {
      this.supplierEmailDefault.forEach((item: any) => {
        item.isChecked = false;
      });

      this.supplierEmailDefault.forEach((x: any) => {
        x.items.forEach((subobject: any) => {
          subobject.isChecked = false;
        });
      });
    }
  }

  supplierHeaderCheckUncheckAll(moduleId: any, trueValue: boolean) {
    const currentPermissionsRow = this.supplierEmailDefault.filter(
      (x: any, i: any) => i == moduleId
    );
    currentPermissionsRow.forEach((x: any) => {
      x.items.forEach((subobject: any) => {
        subobject.isChecked = trueValue;
      });
    });
    if (this.supplierEmailDefault.every((item: any) => item.isChecked)) {
      this.allSupplierChecked = true;
    } else {
      this.allSupplierChecked = false;
    }
  }

  supplierSubHeaderCheckUncheck(moduleId: any, subId: any, trueValue: boolean): void {
    setTimeout(() => {
      if (trueValue) {
        const currentPermissionsRow = this.supplierEmailDefault.find(
          (x: any, i: any) => i == moduleId
        );
        currentPermissionsRow.isChecked = false;
      } else {
        const currentPermissionsRow = this.supplierEmailDefault.find(
          (x: any, i: any) => i == moduleId
        );
        currentPermissionsRow.items.forEach((subobject: any) => {
          if (
            currentPermissionsRow.items.every((item: any) => item.isChecked)
          ) {
            currentPermissionsRow.isChecked = true;
          }
        });
      }
      if (this.supplierEmailDefault.every((item: any) => item.isChecked)) {
        this.allSupplierChecked = true;
      } else {
        this.allSupplierChecked = false;
      }
    }, 200);
  }

  subHeaderCheckUncheck(moduleId: any, subId: any, trueValue: boolean): void {
    setTimeout(() => {
      if (trueValue) {
        const currentPermissionsRow = this.emailDefault.find(
          (x: any, i: any) => i == moduleId
        );
        currentPermissionsRow.isChecked = false;
      } else {
        const currentPermissionsRow = this.emailDefault.find(
          (x: any, i: any) => i == moduleId
        );
        currentPermissionsRow.items.forEach((subobject: any) => {
          if (
            currentPermissionsRow.items.every((item: any) => item.isChecked)
          ) {
            currentPermissionsRow.isChecked = true;
          }
        });
      }
      if (this.emailDefault.every((item: any) => item.isChecked)) {
        this.allChecked = true;
      } else {
        this.allChecked = false;
      }
    }, 200);
  }

  headerCheckUncheckAll(moduleId: any, trueValue: boolean) {
    const currentPermissionsRow = this.emailDefault.filter(
      (x: any, i: any) => i == moduleId
    );
    currentPermissionsRow.forEach((x: any) => {
      x.items.forEach((subobject: any) => {
        subobject.isChecked = trueValue;
      });
    });
    if (this.emailDefault.every((item: any) => item.isChecked)) {
      this.allChecked = true;
    } else {
      this.allChecked = false;
    }
  }
  cancelEmailsDrawer() {
    this.isVisibleEmailsDrawer = false;
    this.hideEmailsDrawer.emit({
      hide: this.isVisibleEmailsDrawer,
      data: null,
    });
  }
  handleOkEmailsDrawer() {
    this.isLoadingOne = true;

    const outputArray = this.emailDefault.flatMap((notification) =>
      notification.items.map((item) => ({
        name: item.item,
        type: notification.header,
        isJustMine: item.isChecked || false,
        isAll: false,
      }))
    );

    const supplierNotificationArray = this.currentSelectedTab == RoleType.Supplier ?
      this.supplierEmailDefault.flatMap((notification) =>
        notification.items.map((item) => ({
          name: item.item,
          type: notification.header,
          isJustMine: item.isChecked || false,
          isAll: false,
        }))
      ) : null;

    var emailDefaultBody = {
      Id: this.selectedRoleDataEmailDefault.id,
      emailDefaultAction: outputArray,
      supplierEmailDefaultsAction: supplierNotificationArray,
      roleType: this.currentSelectedTab
    };

    this._ws.updateEmailDefaultByRole(emailDefaultBody).subscribe(
      (response: any) => {
        if (response.responseStatus == ResponseStatus.success) {
          this.isVisibleEmailsDrawer = false;
          this.hideEmailsDrawer.emit({
            hide: this.isVisibleEmailsDrawer,
            data: response.result,
          });
          this._cs.displayMessage('success', response.message);
          this.isLoadingOne = false;
        } else {
          this._cs.displayMessage('error', response.message);
          this.isLoadingOne = false;
        }
      },
      (error: any) => {
        // this._cs.displayMessage('error', error.message);
        this.isLoadingOne = false;
      }
    );
  }
}
